import AppConstants from 'constants/AppConstants';

export function getApiKeys(): ApiAction {
  return {
    TockApi: {
      getListProto: '/authentication/api-key',
      type: AppConstants.FETCH_TOCK_API_KEY,
    },
  };
}

export function generateApiKey(apiKeyRequest: ApiKeyRequest): ApiAction {
  return {
    TockApi: {
      getProto: `/authentication/api-key/generate?contactEmail=${apiKeyRequest.contactEmail}&description=${apiKeyRequest.description}`,
      type: AppConstants.GENERATE_TOCK_API_KEY,
    },
  };
}

export function disableApiKey(uuid: string): ApiAction {
  return {
    TockApi: {
      getProto: `/authentication/api-key/disable?apiKeyUuid=${uuid}`,
      type: AppConstants.DISABLE_TOCK_API_KEY,
    },
  };
}

export type ApiKeyRequest = { contactEmail: string; description: string };
